import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { useAppSelector } from "app/redux/hooks";
import { RespostaOrcamentoAbertos } from "app/types/cliente/RespostaOrcamentosAbertos";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { OrcamentoEmAberto } from "./OrcamentoEmAberto";
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";

export type OrcamentoEmAbertosContainerProps = {
    codigoCliente: number
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    onRemover: () => boolean
};

const parametroFonteReceita = "UTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA";

export const OrcamentoEmAbertosContainer = (props: OrcamentoEmAbertosContainerProps) => {
    const orcamento = useAppSelector((store) => store.orcamento);
    const [dados, setDados] = useState<Partial<RespostaOrcamentoAbertos>>()
    const [colunaOrdenacao, setColunaOrdenacao] = useState<string>("")
    const [ordemOrdenacaoDecrescente, setOrdemOrdenacaoDecrescente] = useState<boolean>(false)
    const [paramUTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA, setParamUTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA] = useState<boolean>(false)

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const atualizarParametros = useCallback(async () => { // 487678/449093 
            let oidFilial = orcamento?.OidFilialOrcamento ?? 7;
    
            try {
                if (oidFilial > 7) {
                    const param = await obterParametrosPorOidItem(
                        {
                            nomes:
                                [
                                    parametroFonteReceita,
                                ], oidItem: oidFilial
                        })
    
                    setParamUTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA(param.find((p) => p.Nome == parametroFonteReceita)?.Valor == "S") // 487678/449093 
                }
                else {
                    // se chamado fora do orçamento
                    const param = await obterParametros({
                        nomes: [
                            parametroFonteReceita,
                        ],
                    })
    
                    setParamUTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA(param.find((p) => p.Nome == parametroFonteReceita)?.Valor == "S")  // 487678/449093 
                }
    
            }
            catch (e) {
                tratamentoErroPadrao(e)
            }
        }, [orcamento?.OidFilialOrcamento])

    const dadosOrcamentosAbertos = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Cliente.DadosOrcamentoAberto({ Codigo: props.codigoCliente, NumeroPagina: 1, TamanhoPagina: 20 });

            (!("HasErrors" in resultado)) ? setDados(resultado) : (setDados({}), onVoltar())

        }
        catch (e) {
            tratamentoErroPadrao(e)
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const listarOrcamentosAbertos = async (coluna?: string, decrescente?: boolean) => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Cliente.DadosOrcamentoAberto(
                {
                    Codigo: props.codigoCliente,
                    NumeroPagina: 1,
                    TamanhoPagina: 20
                },
                coluna,
                decrescente
            );

            setColunaOrdenacao(coluna ?? "")
            setOrdemOrdenacaoDecrescente(decrescente)
            setDados(resultado)
        }
        catch (e) {
            tratamentoErroPadrao(e)
        }
        finally {
            globalMU.unblockUI();
        }
    }


    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useEffect(() => {
        atualizarParametros() 
        passosInterno.current.set("Orçamentos em Aberto", () => { })
        dadosOrcamentosAbertos();
    }, [])
 
    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                id="OrcamentoEmAbertosContainer"
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <OrcamentoEmAberto
                dados={dados != undefined ? dados.Entities : []}
                cpfCnpj={orcamento.Cliente.CpfCnpj}
                nome={orcamento.Cliente.Nome}
                colunaOrdenacao={colunaOrdenacao}
                ordemOrdenacaoDecrescente={ordemOrdenacaoDecrescente}
                onAlterarOrdenacaoDados={listarOrcamentosAbertos}
                usaFonteDeReceita={paramUTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA} // 487678/449093 
            />
        </>
    )
}